module.exports = __webpack_public_path__ + "img/Logo Square Color_Beta.760eaca.png";